import { Mark } from '@tiptap/core'
import { Plugin } from 'prosemirror-state'

const getCommentNode = (node, cb) => {
  if (!node || node.classList.contains('ProseMirror')) return

  if (node.getAttribute('commentid')) {
    cb(node)
  } else {
    getCommentNode(node.parentNode, cb)
  }
}

export const CommentMark = Mark.create({
  name: 'commentMark',
  inclusive: false,

  addAttributes () {
    return {
      commentid: {
        default: null,
        parseHTML: element => ({ commentid: element.getAttribute('commentid') }),
        renderHTML: attrs => attrs.commentid ? { commentid: attrs.commentid } : {}
      },
      comment: {
        default: null,
        parseHTML: element => ({ comment: element.getAttribute('comment') }),
        renderHTML: attrs => attrs.comment ? { comment: attrs.comment } : {}
      }
    }
  },

  parseHTML () {
    return [
      {
        priority: 51,
        tag: 'span[comment]',
        getAttrs: dom => ({
          comment: dom.getAttribute('comment'),
          commentid: dom.getAttribute('commentid')
        })
      }
    ]
  },

  renderHTML ({ HTMLAttributes }) {
    return ['span', {
      comment: HTMLAttributes.comment,
      commentid: HTMLAttributes.commentid,
      class: 'comment'
    }, 0]
  },

  addCommands () {
    return {
      addCommentMark: attributes => ({ commands }) => {
        return commands.setMark('commentMark', attributes)
      },

      removeCommentMark: () => ({ commands }) => {
        return commands.unsetMark('commentMark')
      }
    }
  },

  addProseMirrorPlugins () {
    return [
      new Plugin({
        props: {
          handleDOMEvents: {
            mouseover (view, event) {
              const mark = event.target

              if (mark?.getAttribute('commentid')) {
                const id = mark.getAttribute('commentid')
                const node = document.querySelector(`span[contentid='${id}']`)

                node.children[0].style.opacity = 1

                const removeOpacity = () => {
                  node.children[0].style.removeProperty('opacity')
                  mark.removeEventListener('mouseleave', removeOpacity)
                }

                mark.addEventListener('mouseleave', removeOpacity)
              }
            }
          },
          handleClickOn: (view, pos, node, nodePos, event) => {
            view.dispatch(view.state.tr.scrollIntoView())

            const mark = event.target

            getCommentNode(mark, el => {
              if (el?.getAttribute('commentid')) {
                event.stopPropagation()

                const id = el.getAttribute('commentid')
                const node = document.querySelector(`span[contentid='${id}']`)

                if (node && typeof node.click === 'function') {
                  setTimeout(() => {
                    node.click()
                  }, 10)
                  return false
                }
              }
            })

            return false
          }
        }
      })
    ]
  }
})
